import { createFormContext } from "@mantine/form";
import type { Wall } from "wall/types/wall.model";
import { wallTemplate } from "wall/types/wall.model";
import {
  DEFAULT_PLAY_BACKGROUND,
  DEFAULT_RED_COLOR,
  DEFAULT_SCREEN_BACKGROUND,
  DEFAULT_WHITE_COLOR,
} from "../../../_graphic_design";

export const [WallFormProvider, useWallFormContext, useWallForm] =
  createFormContext<Omit<Wall, "id">>();

export const defaultWall: Omit<Wall, "id"> = {
  colors: {
    authors: DEFAULT_WHITE_COLOR,
    background: "#02184D",
    buttonBackground: DEFAULT_RED_COLOR,
    buttonBorder: DEFAULT_WHITE_COLOR,
    buttonText: DEFAULT_WHITE_COLOR,
    info: DEFAULT_WHITE_COLOR,
    labels: DEFAULT_WHITE_COLOR,
    mandatory: DEFAULT_RED_COLOR,
    messages: DEFAULT_WHITE_COLOR,
    upload: DEFAULT_WHITE_COLOR,
  },
  entity: "",
  images: {
    screenBackground: DEFAULT_SCREEN_BACKGROUND,
    playBackground: DEFAULT_PLAY_BACKGROUND,
    formLogo: "/psg/logo.png",
    confirmLogo: "/psg/logo.png",
  },
  slideShowStructure: "right-photo",
  msgAuthorFontSize: "40px",
  msgFontSize: "60px",
  name: "",
  organization: "",
  pageTitle: "Inscription",
  section: "",
  template: "bandeau_horizontal" as wallTemplate,
  type: "HYBRID",
  welcomeMsg: "Bienvenue",
  labelFormMessage: "Message",
  sentMessage: "Votre message a bien été envoyé",
  sentButtonLabel: "Envoyer un nouveau message",
  labels: {
    usernameLabel: "Pseudo",
    photoLabel: "Photo",
    addAPhotoLabel: "Ajoutez votre photo",
    takeAPhotoLabel: "Prendre une photo avec l'appareil photo",
    cancellationLabel: "Annuler",
  },
};
